// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.
import { application } from "./application";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

import StimulusReflex from "stimulus_reflex";
import controller from "../controllers/application_controller";

const context = require.context("controllers", true, /_controller\.js$/);
application.load(definitionsFromContext(context));

// import { AbymeController } from "abyme";
// application.register("abyme", AbymeController);

StimulusReflex.initialize(application, { controller, isolate: true });
StimulusReflex.debug = process.env.RAILS_ENV === "development";
